/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./itm-required.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./itm-required.component";
var styles_ItmRequiredComponent = [i0.styles];
var RenderType_ItmRequiredComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ItmRequiredComponent, data: {} });
export { RenderType_ItmRequiredComponent as RenderType_ItmRequiredComponent };
export function View_ItmRequiredComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "span", [["class", "required"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["*"]))], null, null); }
export function View_ItmRequiredComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "itm-required", [], null, null, null, View_ItmRequiredComponent_0, RenderType_ItmRequiredComponent)), i1.ɵdid(1, 114688, null, 0, i2.ItmRequiredComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ItmRequiredComponentNgFactory = i1.ɵccf("itm-required", i2.ItmRequiredComponent, View_ItmRequiredComponent_Host_0, {}, {}, []);
export { ItmRequiredComponentNgFactory as ItmRequiredComponentNgFactory };
